export default "__VITE_ASSET__C6NPG3LY__"